// import GTMScript from "@/component/Ads/GTMScript";

import SVG from "react-inlinesvg";
import ResultTally from "@/component/Result";
import Sponsor from "@/component/Sponsor";
import { getDataFromSSR } from "@/handlers/client/commonClient";
import dynamic from "next/dynamic";
import { useRouter } from "next/router";
// import Head from "next/head";
import { useCallback, useContext, useEffect, useMemo, useRef, useState } from "react";
import { useInView } from "react-intersection-observer";
import ExitPoll from "@/component/ExitPoll";
import { MasterConfigContext } from "@/context/MasterConfigContext";
import StateExitPoll from "@/component/StateExitPoll";
import StateResultTally from "@/component/StateResultTally";
const NoData = dynamic(() => import("@/component/NoData"));

const Breadcrumb = dynamic(() => import("@/component/Breadcrumb"));
const ItemsListSchema = dynamic(() => import("@/component/SeoTags/ItemsList"));
const List1 = dynamic(() => import("@/component/Listing/List1"));
const List2 = dynamic(() => import("@/component/Listing/List2"));
const BreadcrumbSchema = dynamic(() =>
  import("@/component/SeoTags/BreadcrumbSchema")
);
const WebpageSchema = dynamic(() =>
  import("@/component/SeoTags/WebpageSchema")
);
const HeadTag = dynamic(() => import("@/component/SeoTags/HeadTag"));
// const Pagination = dynamic(() => import("@/component/Pagination"));
// const NoData = dynamic(() => import("@/component/NoData"));
const AdSlot300x250 = dynamic(() => import("@/component/Ads/AdSlot300x250"));
const AdSlot728x90 = dynamic(() => import("@/component/Ads/AdSlot728x90"));
const ResultWidget = dynamic(() =>
  import("@/component/NikayChunav/ResultWidget")
);
const BoardsHomeWidget = dynamic(() =>
  import("@/component/BoardResults/BoardsHomeWidget")
);
// const VDOAdsScript = dynamic(() => import("@/component/Ads/VDOAdsScript"));
// const VDOAdSlot = dynamic(() => import("@/component/Ads/VDOAdSlot"));
import PhotosList from "@/component/Listing/PhotosList";
import {
  apstagBidCallback,
  createApsSlotsRosDesktop,
  createApsSlotsRosMobile,
  requestBiddingFromPWT,
} from "@/utils/ads";
import ExitPollRegionalComponentV2 from "@/component/ExitPollRegionalV2";
import MainBanner from "@/component/constituency/MainBanner";
import HomeBanner from "../MPbaithaki/HomeBanner";
import { default as BiharHomeBanner } from "../BiharTakbaithak/HomeBanner";
import ElectionLive from "@/component/ElectionLive";

import BiharConstituencyLiveResult from "@/component/constituency/BiharConstituencyLiveBlogLinks";
import BiharElectionHomeMenuBannerCard from "@/component/constituency/BiharElectionHomeMenuBannerCard";

const Category = ({
  categoryNewsListData = null,
  isMobileDevice = false,
  electionPassedCategory = "",
  masterKey = "",
  metaData = {},
  stateHindi = "",
  stateName = '',
  electionLiveData = null,
  constituencyListData = null,
}) => {
  const [currentPage, setCurrentPage] = useState(1);
  const [categoryData, setCategoryData] = useState(
    categoryNewsListData?.content
  );
  const [firstScroll, setFirstScroll] = useState(false);
  const [hasMore, setHasMore] = useState(true);
  const [loadingSpinner, setLoadingSpinner] = useState(false);

  const [y, setY] = useState(
    typeof window !== "undefined" && document.scrollingElement.scrollHeight
  );
  const [electionCategory, setElectionCategory] = useState(
    electionPassedCategory
  );
  const [scrollDirection, setScrollDirection] = useState(
    "you have not scrolled yet"
  );
  const isFetchingMoreRef = useRef(false);
  const hasTriggeredLoadRef = useRef(false);
  const router = useRouter();
  const isMobileLayout = !!isMobileDevice;

  const isDelhi = router?.asPath.includes("delhi");
  const isBihar = router?.asPath.includes("bihar");
  const isMaharashtra = router?.asPath.includes("maharashtra");
  const isHaryana = router?.asPath.includes("haryana");
  const isJharkhand = router?.asPath.includes("jharkhand");
  const currentPath = (router?.asPath || "")?.split("?")[0];
  const isMP = currentPath.includes("madhya-pradesh");
  const isRJ = currentPath.includes("rajasthan") ;
  const isBH = currentPath.includes("bihar");
  const isHR = currentPath.includes("haryana");
  const isDL = currentPath.includes("delhi");
  const isUP = currentPath.includes("uttar-pradesh");
  const isEducation = currentPath.includes("education");
  const isCGH = currentPath.includes("chhattisgarh");
  const isUK = currentPath.includes("uttarakhand");
  const isPB=currentPath.includes("punjab")
  const isBR_chunav = currentPath.includes("/elections/assembly-chunav/bihar");
  const isNoIndex = router?.asPath?.includes("/xiaomi-astrology");
  const h1Mappings = [
    { slug: "/astrology-news", h1: "ज्योतिष न्यूज़" },
    { slug: "/bihar", h1: "बिहार न्यूज़" },
    { slug: "/business", h1: "बिज़नेस न्यूज़" },
    { slug: "/chhattisgarh", h1: "छत्तीसगढ़ न्यूज़" },
    { slug: "/delhi-news", h1: "दिल्ली न्यूज़" },
    { slug: "/education", h1: "शिक्षा न्यूज़" },
    { slug: "/entertainment", h1: "मनोरंजन न्यूज़" },
    { slug: "/haryana", h1: "हरियाणा न्यूज़" },
    { slug: "/india-news", h1: "भारत Tak" },
    { slug: "/madhya-pradesh", h1: "मध्यप्रदेश न्यूज़" },
    { slug: "/national-news", h1: "नेशनल न्यूज़" },
    { slug: "/news", h1: "ताज़ा न्यूज़" },
    { slug: "/politics", h1: "राजनीति न्यूज़" },
    { slug: "/rajasthan", h1: "राजस्थान न्यूज़" },
    { slug: "/uttar-pradesh", h1: "उत्तर प्रदेश न्यूज़" },
    { slug: "/uttarakhand", h1: "उत्तराखंड न्यूज़" },
    { slug: "/punjab", h1: "पंजाब" },
  ];
  const match = h1Mappings.find((item) => item.slug.includes(currentPath));

  const keyBindings = {
    Category: isMP
      ? "MPTak-Homepage"
      : isRJ
        ? "RJTak-Homepage"
        : isBH && !isBR_chunav
          ? "BiharTak-Homepage"
          : isDL
            ? "DelhiTak-Homepage"
            : isCGH
              ? "ChhattisgarhTak-Homepage"
              : isUK
                ? "UttarakhandTak-Homepage"
                : isHR
                  ? "HRTak-Homepage"
                  : currentPath.split("/").length > 2
                    ? [currentPath.split("/")[1], currentPath.split("/")[2]]
                    : currentPath.split("/")[1],
    Keywords: categoryNewsListData?.seo_detail?.meta_keyword.split(","),
  };
  const isPhotosRoute = currentPath.includes("/photos");
  const isMainElectionPath = currentPath?.includes("/elections");
  const isMain_elections_path = currentPath === "/elections";
  const isVidhansbahaPath = currentPath?.includes("/elections/assembly-chunav");
  const isAssemblyPath = currentPath == "/elections/assembly-chunav";
  useEffect(() => {
    setCategoryData(categoryNewsListData?.content);
  }, [categoryNewsListData?.content]);

  const categoryPath = router?.asPath || "";
  const tempPath = categoryPath?.split("?")[0];
  const currentSubCategory = tempPath?.split("/")[2];

  const masterConfig = useContext(MasterConfigContext);

  const hrElectionKeys = masterConfig["haryana_election"];
  const isIndiaNews = categoryPath.includes("india-news");
  const boardsKeys = masterConfig["boards_result"];
  const mp_baithaki = masterConfig["mp_baithaki"];
  const bihar_baithaki = masterConfig["bihar_baithaki"];
  // ------------bihar election master config----------------------
  const electionKeys = masterConfig[masterKey];
  const menuList = electionKeys?.menuList
  //  [
  //   {
  //     title: "खबरें",
  //     src: "https://akm-img-a-in.tosshub.com/lingo/newstak/resources/prod/khabarSym.svg",
  //     slug: `${electionPassedCategory}/bihar`,
  //   },
  //   ...(electionKeys?.showScheduleTab
  //     ? [
  //         {
  //           title: "शेड्यूल",
  //           src: "https://akm-img-a-in.tosshub.com/lingo/newstak/resources/prod/calender.svg",
  //           slug: `${electionPassedCategory}/bihar/schedule`,
  //         },
  //       ]
  //     : []),
  //   ...(electionKeys?.showConstituencyTab
  //     ? [
  //         {
  //           title: "हर सीट", // "निर्वाचन क्षेत्र",
  //           src: "https://akm-img-a-in.tosshub.com/lingo/newstak/resources/prod/chunavSeat.svg", // "https://akm-img-a-in.tosshub.com/lingo/newstak/resources/prod/i4.gif",
  //           slug: `${electionPassedCategory}/bihar/constituency-list`,
  //         },
  //       ]
  //     : []),

  //   ...(electionKeys?.showKeyCand
  //     ? [
  //         {
  //           title: "VIP सीट", // "प्रमुख उम्मीदवार",
  //           src: "https://akm-img-a-in.tosshub.com/lingo/newstak/resources/prod/keycandidate.svg",
  //           slug: `${electionPassedCategory}/bihar/key-candidates-list`,
  //         },
  //       ]
  //     : []),

  //   ...(electionKeys?.showLiveUpdate
  //     ? [
  //         {
  //           title: "लाइव अपडेट्स", // "प्रमुख उम्मीदवार",
  //           src: "https://akm-img-a-in.tosshub.com/lingo/newstak/resources/prod/liveIcon.gif",
  //           slug: `${electionPassedCategory}/bihar/constituency-list#election-auto-live-blogs`,
  //         },
  //       ]
  //     : []),

  //   ...(electionKeys?.showResult
  //     ? [
  //         {
  //           title: "रिजल्ट", // "चुनाव परिणाम",
  //           src: "https://akm-img-a-in.tosshub.com/lingo/newstak/resources/prod/cup.svg",
  //           slug: `${electionPassedCategory}/bihar/results`,
  //         },
  //       ]
  //     : []),

  //   ...(electionKeys?.showExitPoll
  //     ? [
  //         {
  //           title: "एक्जिट पोल",
  //           src: "https://akm-img-a-in.tosshub.com/lingo/newstak/resources/prod/archive.svg",
  //           slug: `${electionPassedCategory}/bihar/exit-poll`,
  //         },
  //       ]
  //     : []),

  //   ...(electionKeys?.showFaqs
  //     ? [
  //         {
  //           title: `FAQs`,
  //           src: "https://akm-img-a-in.tosshub.com/lingo/newstak/resources/prod/faqSymbol.svg",
  //           slug: `faqs`,
  //         },
  //       ]
  //     : []),
  // ];

  // const handlePageClick = (page) => {
  //   if (currentPage === page) return;
  //   setCurrentPage(page);
  //   let currentPath = router?.asPath?.split("?")[0];
  //   window.location.href = `${currentPath}?page=${page}`;
  // };

  useEffect(() => {
    const handleRouteChangeComplete = (url) => {
      setCurrentPage(1);
      hasTriggeredLoadRef.current = false;
      isFetchingMoreRef.current = false;
    };

    router.events.on("routeChangeComplete", handleRouteChangeComplete);

    return () => {
      router.events.off("routeChangeComplete", handleRouteChangeComplete);
    };
  }, [router.events]);

  const [insightref, insightView] = useInView({
    threshold: 0,
    rootMargin: "40%",
  });
  const [mobileInsightref, mobInsightView] = useInView({
    threshold: 0,
    rootMargin: "40%",
  });

  const getMorePost = useCallback(async () => {
    if (isFetchingMoreRef.current) {
      return;
    }

    isFetchingMoreRef.current = true;
    const websiteUrl = process.env.NEXT_PUBLIC_WEBSITE_URL;
    setLoadingSpinner(true);
    try {
      let fetchedData;
      if (isPhotosRoute) {
        fetchedData = await getDataFromSSR(
          `${websiteUrl}/api/getPhotos?page=${currentPage}`
        );
      } else {
        fetchedData = await getDataFromSSR(
          `${websiteUrl}/api/getCategoryPosts?page=${currentPage}&category=${categoryPath}`
        );
      }
      if (fetchedData?.data?.categoryNewsListData?.content?.length > 0) {
        setCategoryData((prevData = []) => [
          ...prevData,
          ...fetchedData?.data?.categoryNewsListData?.content,
        ]);
      } else if (fetchedData?.data?.photoData?.content?.length > 0) {
        setCategoryData((prevData = []) => [
          ...prevData,
          ...fetchedData?.data?.photoData?.content,
        ]);
      } else {
        setHasMore(false);
      }
    } finally {
      isFetchingMoreRef.current = false;
      setLoadingSpinner(false);
    }
  }, [categoryPath, isPhotosRoute, currentPage]);
  const handleNavigation = useCallback(
    (e) => {
      if (y > window.scrollY) {
        setScrollDirection("Scrolling Up");
      } else if (y < window.scrollY) {
        setScrollDirection("Scrolling Down");
      }

      setY(window.scrollY);
    },
    [y]
  );
  useEffect(() => {
    window.addEventListener("scroll", handleNavigation);

    return () => {
      window.removeEventListener("scroll", handleNavigation);
    };
  }, [handleNavigation]);

  useEffect(() => {
    if (!insightView && !mobInsightView) {
      hasTriggeredLoadRef.current = false;
    }
  }, [insightView, mobInsightView]);

  useEffect(() => {
    if (
      (insightView || mobInsightView) &&
      scrollDirection == "Scrolling Down" &&
      hasMore &&
      !loadingSpinner &&
      !hasTriggeredLoadRef.current &&
      !isFetchingMoreRef.current
    ) {
      hasTriggeredLoadRef.current = true;
      if (!firstScroll) {
        setFirstScroll(true);
      }
      setCurrentPage((prevPage) => prevPage + 1);
    }
  }, [firstScroll, hasMore, insightView, loadingSpinner, mobInsightView, scrollDirection]);

  useEffect(() => {
    if (currentPage < 1) {
      return;
    }
    getMorePost();
    let height = window?.scrollY;
    window.scrollTo(0, height);
  }, [currentPage, getMorePost]);

  const [scrolled, setScrolled] = useState(false);
  useEffect(() => {
    function handleScroll() {
      if (!scrolled) {
        setScrolled(true);
      }
    }
    window.addEventListener("scroll", handleScroll);
    return () => {
      window.removeEventListener("scroll", handleScroll);
    };
  }, []);
  useEffect(() => {
    setTimeout(() => {
      window.googletag = window.googletag || { cmd: [] };

      if (window.screen.width < 900) {
        googletag.cmd.push(function () {
          if (!scrolled) {
            googletag.destroySlots();
            googletag
              .defineSlot(
                "/1007232/News_tak_Mobile_ROS_ATF_300x250",
                [300, 250],
                "div-gpt-ad-1659434453897-0"
              )
              .addService(googletag.pubads());

          }


          if (scrolled) {
            {
              document.getElementById("div-gpt-ad-1659434604998-0") &&
                googletag
                  .defineSlot(
                    "/1007232/News_tak_Mobile_ROS_MTF-1_300x250",
                    [300, 250],
                    "div-gpt-ad-1659434604998-0"
                  )
                  .addService(googletag.pubads());
            }
            if (
              // currentSubCategory == electionCategory &&
              categoryData &&
              categoryData?.length > 5
            ) {
              document.getElementById("div-gpt-ad-1659434785315-0") &&
                googletag
                  .defineSlot(
                    "/1007232/News_tak_Mobile_ROS_MTF-2_300x250",
                    [300, 250],
                    "div-gpt-ad-1659434785315-0"
                  )
                  .addService(googletag.pubads());
            }

            googletag
              .defineSlot(
                "/1007232/News_tak_Mobile_ROS_BTF_300x250",
                [300, 250],
                "div-gpt-ad-1659435474737-0"
              )
              .addService(googletag.pubads());
          }
          if (!scrolled) {
            googletag
              .defineSlot(
                "/1007232/News_tak_Mobile_ROS_Bottom_320x50",
                [320, 50],
                "div-gpt-ad-1659435612077-0"
              )
              .addService(googletag.pubads());
          }
          // // googletag.pubads().enableSingleRequest();
          // googletag.pubads().disableInitialLoad();
          googletag.enableServices();
          googletag.setConfig({disableInitialLoad: true, targeting: keyBindings });
          requestBiddingFromPWT();
          !scrolled &&
            googletag.cmd.push(function () {
              var INTERSTITIALAd = googletag
                .defineOutOfPageSlot(
                  "/1007232/News_tak_Mobile_ROS_Mweb_Interstitial",
                  googletag.enums.OutOfPageFormat.INTERSTITIAL
                )
                .addService(googletag.pubads());

              googletag.display(INTERSTITIALAd);
            });
        });
      } else {
        googletag.cmd.push(function () {
          if (!scrolled) {
            googletag.destroySlots();
            googletag
              .defineSlot(
                "/1007232/News_tak_Desktop_ROS_ATF_728x90",
                [728, 90],
                "div-gpt-ad-1659424515060-0"
              )
              .addService(googletag.pubads());
            document.getElementById("div-gpt-ad-1707804176041-1") &&
              googletag
                .defineSlot(
                  "/1007232/News_tak_Desktop_ROS_ATF_300x250",
                  [300, 250],
                  "div-gpt-ad-1707804176041-1"
                )
                .addService(googletag.pubads());
          }
          if (scrolled) {

            {
              categoryData &&
                categoryData?.length > 7 &&
               document.getElementById("div-gpt-ad-1707804176041-2") && googletag
                  .defineSlot(
                    "/1007232/News_tak_Desktop_ROS_MTF_1_728x90",
                    [728, 90],
                    "div-gpt-ad-1707804176041-2"
                  )
                  .addService(googletag.pubads());
            }
            googletag
              .defineSlot(
                "/1007232/News_tak_Desktop_ROS_BTF_728x90",
                [728, 90],
                "div-gpt-ad-1659425743360-0"
              )
              .addService(googletag.pubads());
          }
          // // googletag.pubads().enableSingleRequest();
          // googletag.pubads().disableInitialLoad();
          googletag.enableServices();
          googletag.setConfig({disableInitialLoad: true, targeting: keyBindings });
          requestBiddingFromPWT();
        });
      }
      if (scrolled) {
        apstag?.fetchBids(
          {
            slots:
              window.screen.width < 900
                ? createApsSlotsRosMobile({ mtf2: true, mtf3: false })
                : createApsSlotsRosDesktop({ mtf2: false, mtf3: false, btf: true }),
            timeout: 2e3,
          },
          apstagBidCallback
        );
      }
    }, 10);

    try {
      // page query params
      const page = parseInt(router?.query?.page);
      if (page) {
        setCurrentPage(parseInt(page));
      }
    } catch (error) {
      console.error(error);
    }
  }, [ scrolled]);
  // console.log("the og image", categoryNewsListData?.seo_detail?.og_image);
  let [title, description, keywords] = [
    categoryNewsListData?.seo_detail?.meta_title,
    categoryNewsListData?.seo_detail?.meta_description,
    categoryNewsListData?.seo_detail?.meta_keyword,
  ];
  if (isIndiaNews) {
    title =
      "India News (इंडिया न्यूज़), Latest India News in Hindi, भारत समाचार, Breaking News and भारत की ताज़ा खबरें - NewsTak.in";
    description =
      "Today's Top News from India at NewsTak.in . Get the latest breaking news, हिन्दी समाचार and updates from India (इंडिया न्यूज़). Covering politics, election, economy, sports, entertainment, and भारत के सभी राज्यों से ताज़ा ख़बरें व ब्रेकिंग न्यूज़.";
    keywords =
      "india news, india news hindi, india news photos, भारतसमाचार, india news videos, breaking india news, breaking news from india, breaking hindi news, breaking news today in hindi, इंडियान्यूज़,भारतकीताज़ाखबरे, हिन्दीसमाचार,";
  }
  if (isMainElectionPath) {
    title = categoryNewsListData?.seo_detail?.meta_title || metaData?.title;
    description =
      categoryNewsListData?.seo_detail?.meta_description ||
      metaData?.description;
    keywords =
      categoryNewsListData?.seo_detail?.meta_keyword || metaData?.keywords;
  }

  if (isPhotosRoute) {
    title = "Trending Photo Gallery: देखें India की Viral Photos - NewsTak";
    description =
      "Viral Photo Gallery: हिंदी में देखें India की वायरल तस्वीरें, Trending न्यूज और लेटेस्ट फोटो गैलरी सिर्फ Newstak पर। हर दिन viral और latest फोटोज की झलक!";
    keywords =
      "India Latest photos News, India photos News in Hindi, India Photos news headlines, breaking photos news, India photos Samachar,News Photos, Photo gallery,photogallery News in Hindi, latest news photos, news pictures, event photo gallery, फोटो गैलरी Samachar,फोटो न्यूज़, फोटो समाचार, फोटो खबरें";
  }
  const firstActive = useMemo(() => {
    let first = false;
    let firstActiveItem = "";
    electionLiveData?.content &&
      Object?.keys(electionLiveData?.content).forEach((key) => {
        if (
          first === false &&
          electionLiveData?.content?.[key]?.status === "1"
        ) {
          firstActiveItem = key;
          first = true;
        }
      });
    return firstActiveItem;
  }, [electionLiveData]);

  const showCategoryItems = firstScroll ? categoryData : categoryNewsListData?.content;
  return (
    <section>
      <HeadTag
        title={title}
        description={description}
        keywords={keywords}
        canonicalUrl={
          router.asPath.includes("/photos")
            ? process.env.NEXT_PUBLIC_WEBSITE_URL + router.asPath
            : process.env.NEXT_PUBLIC_WEBSITE_URL +
            categoryNewsListData?.seo_detail?.canonical_url
        }
        noAuthorTag={false}
        image={categoryNewsListData?.seo_detail?.og_image}
        lcpImage={`${categoryNewsListData?.content?.[0]?.image_small}?size=360:203`}
        robotFollow={!isNoIndex}
      />
      {/* <GTMScript /> */}
      <WebpageSchema
        title={categoryNewsListData?.seo_detail?.meta_title}
        description={categoryNewsListData?.seo_detail?.meta_description}
        keywords={categoryNewsListData?.seo_detail?.meta_keyword}
        canonicalUrl={
          router.asPath.includes("/photos")
            ? process.env.NEXT_PUBLIC_WEBSITE_URL + router.asPath
            : process.env.NEXT_PUBLIC_WEBSITE_URL +
            categoryNewsListData?.seo_detail?.canonical_url
        }
      />
      <BreadcrumbSchema
        breadcrumbList={
          isPhotosRoute
            ? [
              {
                title: "फोटो गैलरी",
                canonical_url: `${process.env.NEXT_PUBLIC_WEBSITE_URL}/photos`,
              },
            ]
            : categoryNewsListData?.category_detail
        }
      />

      <ItemsListSchema data={categoryNewsListData?.content} />
      <Breadcrumb
        breadcrumbList={
          isPhotosRoute
            ? [
              {
                title: "फोटो गैलरी",
                canonical_url: `${process.env.NEXT_PUBLIC_WEBSITE_URL}/photos`,
              },
            ]
            : categoryNewsListData?.category_detail
        }
      />
      {/* <VDOAdsScript /> */}

      <section>
        <div className="mx-4">
          <div className="w-full min-h-[90px] hidden md:block">
            <AdSlot728x90
              divId="div-gpt-ad-1659424515060-0"
              minWidth="728px"
              minHeight="90px"
            />
          </div>
          {isBR_chunav && (
            <div className=" block md:hidden w-full min-h-[250px] max-w-[300px] mx-auto md:mx-0">
              <AdSlot300x250
                divId="div-gpt-ad-1659434453897-0"
                minWidth="300px"
                minHeight="250px"
              />
            </div>
          )}
        </div>

        {mp_baithaki?.showCategoryBanner && isMP && (
          <div className="min-h-[160px]">
            <HomeBanner masterConfigKey={mp_baithaki} />
          </div>
        )}
        {bihar_baithaki?.showCategoryBanner && isBH && !isBR_chunav && (
          <div className="min-h-[160px]">
            <BiharHomeBanner masterConfigKey={bihar_baithaki} />
          </div>
        )}
        {isMainElectionPath && <ExitPoll />}
        {isMainElectionPath && <ResultTally />}

        {(isMain_elections_path || isAssemblyPath) && (
          electionKeys?.showHomeCategoryBanner &&
          <div className="mx-4">
            <BiharElectionHomeMenuBannerCard
              electionKeys={electionKeys}
              electionPassedCategory={"elections/assembly-chunav/bihar"}
            />
          </div>
        )}

        {currentSubCategory == electionCategory && (
          <>
            {/*------------------------- bihar vidhan sabha main banner------------ */}
            <MainBanner electionKeys={electionKeys} />
            {isMainElectionPath && (
              <Sponsor
                color="#EE3436"
                name="चुनाव"
                electionKeys={electionKeys}
              />
            )}
            <div className="flex gap-3  flex-row overflow-x-scroll scrollbar-hide mt-2 mx-4 md:mx-4">
              {menuList?.length > 0 && menuList?.map((item, index) => (
                <a
                  className={`${currentPath === `${menuList[index]?.slug}` ||
                    menuList[index]?.slug ===
                    `${electionPassedCategory}/constituency-list`
                    ? `${isBihar
                      ? "bg-[#CF4C9B]"
                      : isDelhi
                        ? "bg-primary"
                        : isHaryana ? "bg-[#64BC46]" : "bg-primary"
                    } text-white border-2 ${isBihar
                      ? "border-[#CF4C9B]"
                      : isDelhi
                        ? "border-primary"
                        : isHaryana ? "border-[#64BC46]" : "border-primary"
                    }`
                    : `border-2 text-gray-600  ${isBihar
                      ? "hover:text-[#CF4C9B]"
                      : isDelhi
                        ? "hover:text-primary"
                        : isHaryana ? "hover:text-hrDark" : "hover:text-primary"
                    }`
                    } px-3 py-1 rounded-xl whitespace-nowrap flex flex-row items-center gap-1 justify-center `}
                  href={`${process.env.NEXT_PUBLIC_WEBSITE_URL}${menuList[index]?.slug}`}
                  key={item?.slug}
                  target={"_self"}
                >
                  {[
                    "https://akm-img-a-in.tosshub.com/lingo/newstak/resources/prod/liveIcon.gif",
                    "https://akm-img-a-in.tosshub.com/lingo/newstak/resources/prod/i6.gif",
                    "https://akm-img-a-in.tosshub.com/lingo/newstak/resources/prod/i4.gif",
                  ]?.some((icon) => item?.src?.includes(icon)) ? (
                    <img
                      className="h-4 w-4"
                      src={
                        item?.slug?.includes("-assembl-constituency-result")
                          ? "https://akm-img-a-in.tosshub.com/lingo/newstak/resources/prod/i6.gif"
                          : item?.src
                      }
                    />
                  ) : (
                    <SVG className="h-4 w-4" src={item?.src} />
                  )}
                  <p>{item?.title}</p>
                </a>
              ))}
            </div>
          </>
        )}

        {(currentPath == `/elections/assembly-chunav` ||
          currentPath == `/elections` || currentPath == `/elections/assembly-chunav/bihar`) && (
            <div className="mx-4 md:mx-4 md: py-2">
              {electionKeys?.newExitPoll && (
                <div className=" ">
                  <h2 className="text-2xl font-semibold my-1">एग्जिट पोल्स</h2>
                  <ExitPollRegionalComponentV2 masterKey="bihar_election" />
                </div>
              )}
              {electionKeys?.showExitPollTally && <StateExitPoll masterKey={"bihar_election"} />}

              <StateResultTally masterKey={"bihar_election"} />
            </div>
          )}
        {isMobileLayout && (
          <div className="top-layer-election " style={{ position: "sticky" }}>
            <ElectionLive
              electionLiveData={electionLiveData?.content}
              firstActive={firstActive}
            />
          </div>
        )}
        <div className="px-2">
          {boardsKeys?.showHomeWidget &&
            (isUP || isEducation) &&
            (boardsKeys.show10result || boardsKeys.show12result) && (
              <BoardsHomeWidget
                isMobileDevice={isMobileDevice}
                result10={boardsKeys?.show10result}
                result12={boardsKeys?.show12result}
                hybridResult={
                  boardsKeys?.show10result && boardsKeys?.show12result
                }
                stateKey={boardsKeys?.stateKey || "up"}
                show10form={boardsKeys?.show10form}
              />
            )}
        </div>
        {isMain_elections_path && (
          <h1 className="text-2xl font-bold mx-4 my-3 text-[#CF4C9B]">
            {stateHindi} चुनाव 2026 ({stateName} Election 2026)
          </h1>
        )}
        {isVidhansbahaPath && (
          <h1 className="text-2xl font-bold mx-4 my-3 text-[#CF4C9B]">
            {stateHindi} विधानसभा चुनाव 2026 ({stateName} Assembly Election)
          </h1>
        )}
        {hrElectionKeys?.showNikayWidget && isHR && (
          <ResultWidget isMobileDevice={isMobileDevice} />
        )}
        {isMobileLayout ? (
          <div className="mx-3 md:mx-3 md: py-2">
            {!isPhotosRoute && (
              <List1
                title={
                  isMainElectionPath
                    ? ""
                    : match
                      ? match.h1
                      : categoryNewsListData?.title
                }
                newsListData={showCategoryItems}
                isLCP={true}
                haveH1={true}
                showAds={scrolled ? true : !isBR_chunav}
                election={isBR_chunav ? true : false}
                scrolled={scrolled}
              />
            )}
            {/* mtf-1 */}
            {/* <AdSlot300x250
                divId="div-gpt-ad-1659434604998-0"
                minWidth="300px"
                minHeight="250px"
              /> */}
            {isPhotosRoute && (
              <PhotosList
                title={isMainElectionPath ? "" : categoryNewsListData?.title}
                newsListData={showCategoryItems}
                isLCP={true}
                showAds={isMobileDevice ? true : false}
                haveH1={true}
                scrolled={scrolled}
                isMtf2={false}
              />
            )}
            <div
              className="text-sports news-load h-[50px] w-full mb-4"
              ref={mobileInsightref}
            >
              {loadingSpinner === true && (
                <div className="flex items-center justify-center">
                  <div className="animate-spin rounded-full border-t-4 border-primary border-solid h-12 w-12"></div>
                </div>
              )}
            </div>
          </div>
        ) : (
          <div className="mx-3 md:mx-3 md:px-2 py-2">
            {!isPhotosRoute && (
              <List2
                title={
                  isMainElectionPath
                    ? ""
                    : match
                      ? match.h1
                      : categoryNewsListData?.title
                }
                newsListData={showCategoryItems}
                isLCP={true}
                showAds={isMobileDevice ? false : true}
                haveH1={true}
                scrolled={scrolled}
              />
            )}
            {isPhotosRoute && (
              <PhotosList
                title={isMainElectionPath ? "" : categoryNewsListData?.title}
                newsListData={showCategoryItems}
                isLCP={true}
                showAds={isMobileDevice ? true : false}
                haveH1={true}
                scrolled={scrolled}
              />
            )}
            <div
              className="text-sports news-load h-[50px] w-full mb-4"
              ref={insightref}
            >
              {loadingSpinner === true && (
                <div className="flex items-center justify-center">
                  <div className="animate-spin rounded-full border-t-4 border-primary border-solid h-12 w-12"></div>
                </div>
              )}
            </div>
          </div>
        )}

        {categoryNewsListData?.content?.length === 0 &&
          categoryData?.length === 0 && <NoData message="No Data Found" />}
        {scrolled && (
          <div className="mx-4 md:mx-4 md:py-2">
            <div className="  mx-auto md:mx-0">
              <AdSlot300x250
                divId="div-gpt-ad-1659435474737-0"
                minWidth="300px"
                minHeight="250px"
              />
            </div>
            <div className="w-full   hidden md:block">
              <AdSlot728x90
                divId="div-gpt-ad-1659425743360-0"
                minWidth="720px"
                minHeight="90px"
              />
            </div>
          </div>
        )}
        {electionKeys?.autoLiveBlog && (
          <div className="mx-2">
            <BiharConstituencyLiveResult
              electionPassedCategory={electionPassedCategory}
              electionConfigData={electionKeys}
            />
          </div>
        )}
        {/* <Pagination
          handlePageClick={handlePageClick}
          currentPage={currentPage}
          totalPages={totalPages}
        /> */}
      </section>
    </section>
  );
};

export default Category;
